import { supabase } from './supabase'
import type {
  NominateTeamResponse,
  VoteForTeamResponse,
  VoteStatusResponse,
  ExecuteQuestResponse,
  AssassinateMerlinResponse,
  NightPhaseResponse
} from '../types/game'

/**
 * 提名队伍 - 队长选择执行任务的队员
 */
export async function nominateTeam(
  sessionId: number,
  teamMemberIds: number[]
): Promise<NominateTeamResponse> {
  const { data, error } = await supabase.rpc('nominate_team', {
    p_session_id: sessionId,
    p_team_member_ids: teamMemberIds
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as NominateTeamResponse
}

/**
 * 投票表决 - 玩家对提名的队伍进行投票
 */
export async function voteForTeam(
  sessionId: number,
  playerId: number,
  vote: boolean // true = 同意，false = 反对
): Promise<VoteForTeamResponse> {
  const { data, error } = await supabase.rpc('vote_for_team', {
    p_session_id: sessionId,
    p_player_id: playerId,
    p_vote: vote
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as VoteForTeamResponse
}

/**
 * 查询投票状态 - 获取当前投票的详细信息
 */
export async function getVoteStatus(sessionId: number): Promise<VoteStatusResponse> {
  const { data, error } = await supabase.rpc('get_vote_status', {
    p_session_id: sessionId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as VoteStatusResponse
}

/**
 * 执行任务 - 被选中的队员选择任务结果
 */
export async function executeQuest(
  sessionId: number,
  playerId: number,
  questResult: 'success' | 'fail'
): Promise<ExecuteQuestResponse> {
  const { data, error } = await supabase.rpc('execute_quest', {
    p_session_id: sessionId,
    p_player_id: playerId,
    p_quest_result: questResult
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as ExecuteQuestResponse
}

/**
 * 刺杀梅林 - 刺客选择刺杀目标
 */
export async function assassinateMerlin(
  sessionId: number,
  assassinPlayerId: number,
  targetPlayerId: number
): Promise<AssassinateMerlinResponse> {
  const { data, error } = await supabase.rpc('assassinate_merlin', {
    p_session_id: sessionId,
    p_assassin_player_id: assassinPlayerId,
    p_target_player_id: targetPlayerId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as AssassinateMerlinResponse
}

/**
 * 开始夜间流程
 */
export async function startNightPhase(sessionId: number): Promise<NightPhaseResponse> {
  const { data, error } = await supabase.rpc('start_night_phase', {
    p_session_id: sessionId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as NightPhaseResponse
}

/**
 * 梅林睁眼识别队友
 */
export async function merlinReveal(
  sessionId: number,
  merlinPlayerId: number
): Promise<NightPhaseResponse> {
  const { data, error } = await supabase.rpc('merlin_reveal', {
    p_session_id: sessionId,
    p_merlin_player_id: merlinPlayerId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as NightPhaseResponse
}

/**
 * 派西维尔睁眼识别梅林和莫甘娜
 */
export async function percivalReveal(
  sessionId: number,
  percivalPlayerId: number
): Promise<NightPhaseResponse> {
  const { data, error } = await supabase.rpc('percival_reveal', {
    p_session_id: sessionId,
    p_percival_player_id: percivalPlayerId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as NightPhaseResponse
}

/**
 * 结束夜间流程，开始游戏
 */
export async function endNightPhase(
  sessionId: number,
  playerId: number
): Promise<NightPhaseResponse> {
  const { data, error } = await supabase.rpc('end_night_phase', {
    p_session_id: sessionId,
    p_player_id: playerId
  })

  if (error) {
    return { success: false, error: error.message }
  }

  return data as NightPhaseResponse
}
